import { useState } from "react";
import { Route } from "react-router-dom";
import Sidebar from "./sidebar";
import Paper from "./paper";
import Roles from "./roles";

export default function Data() {
  const [active, setActive] = useState(null);
  const [activeTab, setActiveTab] = useState("tables");

  const toggle = (tab) => {
    (tab === "tables") ? setActiveTab("roles") : setActiveTab("tables");
  }

  return (
    <Route path="/:appId/database/:type/:docId">
      <div style={{ display: "flex", width: "100%" }} className="page">
        <Sidebar tab={activeTab} toggle={toggle} active={active} setActive={setActive} />
        <Paper open={activeTab === "tables"} active={active} setActive={setActive} />
        <Roles open={activeTab === "roles"} active={active} setActive={setActive} />
      </div>
    </Route>
  );
}
